const firebaseConfig = {
    apiKey: "AIzaSyAL3nqsvQR-ODdM1AdhkzjlrP7ZTx6HhfE",
    authDomain: "travello-fcf45.firebaseapp.com",
    projectId: "travello-fcf45",
    storageBucket: "travello-fcf45.appspot.com",
    messagingSenderId: "200041924567",
    appId: "1:200041924567:web:7670e41c6d84761f11ed92"
};

export default firebaseConfig;